import React from "react";
import semaGuideLarge from '../../../assets/books/kapaklar/sema-guide-600.jpg';
import semaGuideMini from '../../../assets/books/kapaklar/sema-guide-300.jpg';
export const SemaGuideDescription = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img src={semaGuideLarge}
                    alt="Aşka Meşke Semaya Yolculuk"
                    srcSet={`${semaGuideMini} 300w, ${semaGuideLarge} 600w`}
                    sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                The Sufi path is a living process, a school of life. This school teaches people how to take off their ego’s armor and to search for the sun behind the sun.

                Like other Sufi paths, the Mawlawi School admits spiritually unrefined people. It guides them through several training steps, teaching them about their duties and responsibilities in the world.

                Sufism develops not-so-popular attributes like patience, diligence, benevolence, and compassionate tolerance. Its goal is to foster a mature human who understands that serving the creation is a form of praise.

                We must refrain from meddling with the knowledge and practice presented in this book. This jewel of wisdom was sharpened for centuries and lost nothing from its luster. Therefore, demanding to add new essentials to the Sufi path is crossing the line. Such a claim is unsupported, rising from not knowing how little one knows. The Sufi path is the key to personal and worldwide solutions.

                You are also invited to see if this path is worth taking. Along with sincere intention, knowledge, surrender, action, and Sema, another pillar of learning is sohbet, an essential to the Sufi tradition and this book.

                Our goal is to unblock springs, so they can flow abundantly. We have applied all our strength to this project and related our experiences truthfully and respectfully.
            </p>
        </div>
    )
}
export const SemaGuideSummaryDescription = (props: any) => {
    return (
        <p>
                The Sufi path is a living process, a school of life. This school teaches people how to take off their ego’s armor and to search for the sun behind the sun.

                Like other Sufi paths, the Mawlawi School admits spiritually unrefined people. It guides them through several training steps, teaching them about their duties and responsibilities in the world.
        </p>
    )
}